import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-menu-card-el',
  imports: [],
  templateUrl: './menu-card-el.component.html',
  styleUrl: './menu-card-el.component.scss'
})
export class MenuCardElComponent {
  @Input() background: string = '/app/assets/images/asia.png';
  @Input() style: string = '';

}
